import { lazy } from "react";
import { RoleGuard } from "../contexts/RoleGuard";
import { AuthGuard } from "../utils/AuthGuard";
import { ScreenLoader } from "../utils/ScreenLoader";

const CreditTransaction = ScreenLoader(lazy(() => import("../screens/CreditTransaction")));
export const CreditTrancsactionRoute = () => ({
  path: "credit-transaction",
  element: (
    <AuthGuard>
      <RoleGuard requiredPermission="creditTransaction" requiredActions={["isRead"]}>
        <CreditTransaction />
      </RoleGuard>
    </AuthGuard>
  ),
});
